var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Tooltip } from '@mui/material';
import { IconByName } from '../../utils/IconByName';
import colors from '../../colors';
import Typography from '../Typography';
import isNaN from 'lodash/isNaN';
export var pillTestId = 'sweep-pill';
var Pill = function (_a) {
    var value = _a.value, tooltipTitle = _a.tooltipTitle, startIconName = _a.startIconName, _b = _a.backgroundColor, backgroundColor = _b === void 0 ? colors.grey[120] : _b, _c = _a.tooltipPlacement, tooltipPlacement = _c === void 0 ? 'top' : _c, _d = _a.enableMax, enableMax = _d === void 0 ? false : _d, onClick = _a.onClick;
    var textColor = colors.grey[800];
    var isNumber = !isNaN(Number(value));
    return (_jsx(Tooltip, __assign({ title: tooltipTitle, placement: tooltipPlacement }, { children: _jsxs(Box, __assign({ "data-testid": pillTestId, sx: {
                border: "2px solid ".concat(backgroundColor),
                borderRadius: '100px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 0.5,
                backgroundColor: backgroundColor,
                width: 'fit-content',
                padding: '4px',
                minWidth: '48px',
                maxHeight: '24px',
                '&:hover': {
                    borderColor: colors.blue[500],
                },
            }, onClick: function (event) { return onClick && onClick(event); } }, { children: [startIconName && _jsx(IconByName, { name: startIconName, color: textColor }), _jsx(Typography, __assign({ variant: "caption", color: textColor }, { children: enableMax && isNumber && Number(value) > 99 ? '+99' : value }))] })) })));
};
export default Pill;
